module.exports = __webpack_public_path__ + "img/ico-jf.b9c6a9dd.png";